import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';

import Master from 'front/MasterAdmin';
import Grid from 'front/ProjectsGrid';
import React from 'react';

export const Projets = () => {

    return <Master>
        <Container maxWidth={false}><Typography variant={'h1'}>Mes projets</Typography>
            <Grid />
        </Container></Master>
        ;
};
